import request from '@/utils/request'

const getUserBonus = () => {
  return request({
    url: '/api/bonus',
    method: 'get'
  })
}

const activateBonus = code => {
  return request({
    url: `/api/bonus/activate/${code}`,
    method: 'get'
  })
}

const checkBonusActive = () => {
  return request({
    url: '/api/bonus/check/active',
    method: 'get'
  })
}

const checkMinimum = () => {
  return request({
    url: '/api/bonus/check/minimum',
    method: 'get'
  })
}

const clearBonus = () => {
  return request({
    url: '/api/bonus/clear',
    method: 'get'
  })
}

export default {
  getUserBonus,
  activateBonus,
  checkBonusActive,
  checkMinimum,
  clearBonus
}
